import { getLocalTime } from '../../../common/utils/time/time';

const DEFAULT_EXPIRY_THRESHOLD_DAYS = 7;

// Shared formatting for pick list summary expiry warnings (list + summary dialog).
export const getPickListSummaryExpiryWarningTexts = ({
	expiryWarnings,
	expiryThresholdDays = DEFAULT_EXPIRY_THRESHOLD_DAYS,
	tenantTimezone,
}) => {
	if (!expiryWarnings) {
		return {
			mandatoryWarningText: null,
			optionalWarningText: null,
			expiresBeforeNextServiceText: null,
			expiresBeforeNextServiceAdditionalText: null,
		};
	}

	const {
		expiredProductsCount = 0,
		expireTodayCount = 0,
		unknownExpiryCount = 0,
		productsExpiringWithinXDaysCount = 0,
		expiringBeforeNextServiceCount = 0,
		soonestExpiryBeforeNextService,
	} = expiryWarnings;

	const mandatoryWarnings = [];
	const optionalWarnings = [];

	if (expiredProductsCount) {
		mandatoryWarnings.push(`${expiredProductsCount} product(s) expired`);
	}
	if (expireTodayCount) {
		mandatoryWarnings.push(`${expireTodayCount} product(s) expire today`);
	}
	if (productsExpiringWithinXDaysCount) {
		optionalWarnings.push(`${productsExpiringWithinXDaysCount} product(s) expire within ${expiryThresholdDays} days`);
	}
	if (unknownExpiryCount) {
		optionalWarnings.push(`${unknownExpiryCount} product(s) have unknown expiry`);
	}

	let expiresBeforeNextServiceText = null;
	let expiresBeforeNextServiceAdditionalText = null;
	if (expiringBeforeNextServiceCount) {
		const productLabel = 'product(s)';
		const verbLabel = expiringBeforeNextServiceCount === 1 ? 'expires' : 'expire';
		expiresBeforeNextServiceText = `${expiringBeforeNextServiceCount} ${productLabel} ${verbLabel} before next service`;

		if (soonestExpiryBeforeNextService) {
			const timezone = tenantTimezone || 'Australia/Melbourne';
			const currentDate = getLocalTime(timezone).startOf('day');
			const soonestExpiry = getLocalTime(timezone, soonestExpiryBeforeNextService).startOf('day');
			const daysUntilSoonestExpiry = soonestExpiry.diff(currentDate, 'days');
			const daysLabel = daysUntilSoonestExpiry === 1 ? 'day' : 'days';
			expiresBeforeNextServiceAdditionalText = `in ${daysUntilSoonestExpiry} ${daysLabel}`;
		}
	}

	return {
		mandatoryWarningText: mandatoryWarnings.length > 0 ? mandatoryWarnings.join('\n') : null,
		optionalWarningText: optionalWarnings.length > 0 ? optionalWarnings.join('\n') : null,
		expiresBeforeNextServiceText,
		expiresBeforeNextServiceAdditionalText,
	};
};

